import { ContactTypeIds } from "../environment";

export const ContactTypeKeys = {
  [ContactTypeIds.AGENT]: 'ContactType.Labels.Agent',
  [ContactTypeIds.STEVEDORE]: 'ContactType.Labels.Stevedore',
  [ContactTypeIds.PORT_STAFF]:     'ContactType.Labels.PortStaff',
  [ContactTypeIds.VESSEL_AGENT]:     'ContactType.Labels.VesselAgent',
  [ContactTypeIds.VESSEL_MASTER]:     'ContactType.Labels.VesselMaster',
};